import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  LabelText,
  HiddenCheckbox,
  ToggleBackground,
  ToggleCircle,
} from './components/ToggleStyles';
import { useToggle } from './hooks/useToggle';
import { getToggleLabel } from './utils/toggleHelpers';

const Toggle = ({ checked, onChange, label, disabled, ...rest }) => {
  const { handleChange } = useToggle({ onChange, disabled });
  const displayLabel = getToggleLabel(label);

  return (
    <Container disabled={disabled}>
      <HiddenCheckbox checked={checked} onChange={handleChange} disabled={disabled} {...rest} />
      <ToggleBackground checked={checked} disabled={disabled}>
        <ToggleCircle checked={checked} />
      </ToggleBackground>
      {displayLabel && <LabelText>{displayLabel}</LabelText>}
    </Container>
  );
};

Toggle.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

Toggle.defaultProps = {
  checked: false,
  onChange: undefined,
  label: '',
  disabled: false,
};

export default Toggle;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Toggle/Toggle.jsx